// extracted by mini-css-extract-plugin
export var highlightFade = "_2t-4";
export var highlighted = "_2t-3";
export var table = "_2t-1";
export var tableContainer = "_2t-0";
export var totalsRow = "_2t-2";